import CmdIcon from '@commander-services/cmd-icon';
import * as React from 'react';
import { useIntl } from 'react-intl';
import CmdSvigIcon from '../CmdSvgIcon';

export interface IBulkOperationAction {
  id: string;
  icon?: string;
  colorIcon?: string;
  svgIcon?: JSX.Element;
  name: string;
  callback: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  tooltip?: string;
}

interface IBulkOperationsProps<T> {
  actions: IBulkOperationAction[];
  selectedRows: T[];
  totalCount: number;
}

function BulkOperations<T>(props: IBulkOperationsProps<T>): JSX.Element | null {
  const { formatMessage: f } = useIntl();

  return props.selectedRows.length > 0 ? (
    <div className="cmd-table-selection-summary">
      <div className="cmd-selection-bar">
        <div className="selection-info">
          <span>{f({ id: 'table.rideBook.chosen' })}:</span>
          <span className="record-count font-weight-bold">
            {props.selectedRows.length}/{props.totalCount}
          </span>
        </div>
        <div className="selection-actions">
          {props.actions.map((action: IBulkOperationAction) => (
            <a
              key={`bulk-action-item-${action.id}`}
              onClick={action.callback}
              className="e-button"
              href="#"
              data-cy={`multiple-action_${action.id}`}
              title={action.tooltip || undefined}
            >
              {action.icon && <CmdIcon name={action.icon} />}
              {action.colorIcon && <CmdSvigIcon name={action.colorIcon} />}
              {action.svgIcon}
              {action.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  ) : null;
}

export default BulkOperations;
